import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { OktaService } from '../../shared/services/okta.service';
import { Footer, requestBypassCodePayload, requestPayload } from '../../shared/models/model';
import { Router } from '@angular/router';
import { FooterService } from '../../shared/services/footer.service';
import { Subscription } from 'rxjs';
import config from '../../../assets/config.json';

@Component({
  selector: 'app-bypascode',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './bypasscode.component.html',
  styleUrl: './bypasscode.component.scss',
})
export class BypasscodeComponent implements OnInit, OnDestroy {
  mfaForm: FormGroup = new FormGroup({});
  isError: boolean = false;
  errorMsg: string = '';
  footerData: Footer | undefined;
  MFALoginKeyName: string = config.MFALoginKeyName;
  footerDataSubscription: Subscription = new Subscription();

  constructor(
    private _fb: FormBuilder,
    private _oktaService: OktaService,
    private _router: Router,
    private _footerService: FooterService,
  ) {}

  ngOnInit(): void {
    this.getFooter();
    this.createForm();
  }
  createForm(): void {
    this.mfaForm = this._fb.group({
      securityCode: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{5,6}$'), Validators.minLength(5), Validators.maxLength(6)],
      ],
      remind: [false],
    });
  }

  onSubmit(): void {
    const payload: requestBypassCodePayload = {
      requestingSystem: 'FinPro',
      browserName: this._oktaService.getBrowserName(),
      bypassCode: this.mfaForm.value.securityCode,
    };
    this._oktaService.validateByPassCode(payload)?.subscribe({
      next: (_data) => {
        if (_data?.action === 'Success') {
          this.saveMFAToken(_data?.a9b7xk_0q);
          this._router.navigate(['advisor']);
        }
      },
      error: (err) => {
        if (err?.error?.errors?.BypassCode?.length) {
          this.errorMsg = err.error.errors.BypassCode[0];
        } else if (err?.error?.responseCode === 2 && err?.error?.action === 'PassCode') {
          this.errorMsg = err.error.response;
        }
        this.isError = true;
        setTimeout(() => {
          this.isError = false;
        }, 3000);
        setTimeout(() => {
          const firstInvalidControl = document.querySelector('.is-required.ng-invalid');
          if (firstInvalidControl) {
            (firstInvalidControl as HTMLElement).focus();
          }
        }, 100);
      },
    });
  }

  getFooter() {
    const payLoad: requestPayload = {
      requestingSystem: 'FinPro',
    };
    this.footerDataSubscription = this._footerService?.getFooterData(payLoad)?.subscribe((data: Footer) => {
      this.footerData = data;
      this._footerService.setComplianceID(this.footerData.bypassCodeComplianceId);
    });
  }

  saveMFAToken(token: string): void {
    const date = new Date(Date.now() + Number(config.idleAppMfaTimeOut)); // Set expiration date using config.idleAppMfaTimeOut
    const expires = 'expires=' + date.toUTCString(); // Convert the date to UTC string
    const encodedToken = btoa(token); // Base64 encode the token to ensure it's safely stored
    // Set the cookie with the 'Secure' and 'Path' attributes
    document.cookie = `${this.MFALoginKeyName}=${encodedToken}; ${expires}; path=/; Secure;`;
  }

  ngOnDestroy(): void {
    this.footerDataSubscription.unsubscribe();
  }
}
